import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import noop from 'lodash/noop';
import filter from 'lodash/filter';
import classnames from 'classnames';
import MfeSearchDropDown from '../../components/MfeSearchDropDown/MfeSearchDropDown';
import Notification from '../../containers/Notification/Notification';
// icons
import MfeNavHelpIcon from 'zignal-landscape/lib/Icon/MfeNavHelpIcon';
import MfeNavUserIcon from 'zignal-landscape/lib/Icon/MfeNavUserIcon';
import DropdownIcon from 'zignal-landscape/lib/Icon/DropdownIcon';

const HELP_LINKS = [{
  title: 'Help Portal',
  subtitle: 'All Help Articles',
  link: 'https://zignallabs.freshdesk.com/support/solutions'
}];

const USER_LINKS = [{
  title: 'MY SETTINGS',
  link: '/profile/'
}, {
  title: 'LOGOUT',
  link: '/auth/logout/'
}];

const DEFAULT_STYLES = {};
const DEFAULT_USER = {};
const DEFAULT_WHITELABEL = {};

const NavBar = ({
  styles = DEFAULT_STYLES,
  user = DEFAULT_USER,
  whitelabel = DEFAULT_WHITELABEL,
  timezoneOffset = 0,
  campaigns,
  selectedCampaign,
  navigateBackBone = noop,
  navigateNotificationBackBone,
  handleCampaignChange = noop,
  isDashboardUser
}) => {
  const fullName = `${user.first_name} ${user.last_name}`.toUpperCase();

  const campaignContainerClasses = { [styles.NavBarDropDownButton]: true, [styles.NavBarCampaignDropDownButton]: true };
  const selectedCampaignId = selectedCampaign ? selectedCampaign.id : null;
  const campaignItems = filter(campaigns, ({active, id}) => {
    return active || (selectedCampaignId && id === selectedCampaignId);
  });

  const onCampaignItemClick = useCallback((e, {id}) => handleCampaignChange(id), [navigateBackBone]);
  const onHelpItemClick = useCallback((e, {link}) => {
    if (link.indexOf('/') === 0) {
      navigateBackBone(e);
    }
  }, [navigateBackBone]);
  const onUserItemClick = useCallback((e, {link}) => {
    if (link.indexOf('/') === 0) {
      navigateBackBone(e);
    }
  }, [navigateBackBone]);

  return (<div className={styles.NavBar}>
    <a
      className={styles.NavBarLogo}
      href={isDashboardUser ? null : '/home/'}
      style={isDashboardUser ? {cursor: 'default'} : null}
    >
      <img src={whitelabel.app_logo_img} />
    </a>
    {
      isDashboardUser ? null : (
        <>
          { selectedCampaign &&
            <MfeSearchDropDown
              testId="navbar-campaign-dropdown"
              placeholder="Workspace..."
              className={classnames(campaignContainerClasses)}
              classNameActive={styles.NavBarDropDownButtonActive}
              items={campaignItems}
              activeItemId={selectedCampaign.id}
              isSearchable
              onItemsClick={onCampaignItemClick}
            >
              <div className={styles.NavBarButtonContent}>
                <div className={styles.NavBarButtonText}>{selectedCampaign.title}</div>
                <div className={styles.NavBarDropDownChevron}><DropdownIcon height={10} width={10} /></div>
              </div>
            </MfeSearchDropDown>
          }
          <div className={styles.NavBarButtonContainer}>
            <MfeSearchDropDown
              testId="navbar-help-dropdown"
              className={styles.NavBarButton}
              classNameActive={styles.NavBarDropDownButtonActive}
              items={HELP_LINKS}
              onItemsClick={onHelpItemClick}
            >
              <div className={styles.NavBarButtonContent}>
                <div className={styles.NavBarButtonIcon}><MfeNavHelpIcon /></div>
              </div>
            </MfeSearchDropDown>
            <Notification
              timezoneOffset={timezoneOffset}
              parentStyles={styles}
              navigate={navigateNotificationBackBone}
            />
            <MfeSearchDropDown
              testId="navbar-user-dropdown"
              className={styles.NavBarDropDownButton}
              classNameActive={styles.NavBarDropDownButtonActive}
              items={USER_LINKS}
              onItemsClick={onUserItemClick}
            >
              <div className={styles.NavBarButtonContent}>
                <div className={styles.NavBarUserIcon}><MfeNavUserIcon height={24} width={24} /></div>
                <div className={styles.NavBarButtonText}>{fullName}</div>
                <div className={styles.NavBarDropDownChevron}><DropdownIcon height={10} width={10} /></div>
              </div>
            </MfeSearchDropDown>
          </div>
        </>
      )
    }
  </div>);
};

NavBar.propTypes = {
  styles: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  whitelabel: PropTypes.object.isRequired,
  timezoneOffset: PropTypes.number.isRequired,
  navigateBackBone: PropTypes.func.isRequired,
  handleCampaignChange: PropTypes.func.isRequired,
};

export default themeable(NavBar);
